import { useEffect, useRef, useState } from "react";

const HERO_PHOTO =
  "https://customer-assets-39nsmqrw.emergentagent.net/job_menu-sekantor/artifacts/ybtdcx1o_Colleagues_eating_Indonesian_mar%E2%80%A6_2K_202608192154.webp";

const IMG_BASE = "https://static.prod-images.emergentagent.com/jobs/ca0a234e-f991-4cec-949f-521a6c6255fc/images/";
const POV_PEMBELI = "https://customer-assets-39nsmqrw.emergentagent.net/job_menu-sekantor/artifacts/ml44bohr_Tab%20-%20Pembeli.jpeg";
const POV_REKAN   = "https://customer-assets-39nsmqrw.emergentagent.net/job_menu-sekantor/artifacts/3mdxb63e_Tab%20-%20Rekan%20Masak.jpeg";
const P = {
  padang:  IMG_BASE + "f0e5ad734b3119b7f6f111a277d91228f075b4bbc31ba9e8ac5ab1eea4750183.jpeg",
  ayam:    IMG_BASE + "2fd1b1fd332b2293f37338fcd3c6562180d067ac3b2cfe70b49314776a6bbcae.jpeg",
  esteh:   IMG_BASE + "deb605eb53e13b8942ac4c90a4eef1ae6c31a1a2804d80d79cf3bc941ff2552a.jpeg",
  mie:     IMG_BASE + "ac0903556650983f74802e7c2c87eb9397e8ec4054b811ce05902a76a2de8ae7.jpeg",
  soto:    IMG_BASE + "8f2a80afdbe362a7e19ad209768336dd4ab09ee084113e0ecbc17f3787406e3a.jpeg",
  esjeruk: IMG_BASE + "0987455530ba98b0e21360c77fbb5c14d075db10c4e268a37904d83d65d2763d.jpeg",
  gado:    IMG_BASE + "f759ee20e764693fc58205e5bbd8096d55d0c89d86166f061669200d8fe4d61a.jpeg",
};

const RIBBON_COLORS = {
  "PROMO LAUNCHING 15%": "#E8823A",
  "MENU TERBARU": "#1A17E0",
  "MENU TERLARIS": "#B3261E",
  "PALING SERING DIPESAN": "#2F7A3D",
};

const M = {
  nasiKuningKomplit:    "/marquee/nasi-kuning-komplit.png",
  beefBroccoliBowl:     "/marquee/beef-broccoli-bowl.png",
  esKopiSusu:           "/marquee/es-kopi-susu.png",
  nasiCumiCabeHijau:    "/marquee/nasi-cumi-cabe-hijau.png",
  saladAyamPanggang:    "/marquee/salad-ayam-panggang.png",
  nasiAyamSaltedEgg:    "/marquee/nasi-ayam-salted-egg.png",
  esJerukPeras:         "/marquee/es-jeruk-peras.png",
  esKopiHitam:          "/marquee/es-kopi-hitam.png",
  nasiKuningAyamSuwir:  "/marquee/nasi-kuning-ayam-suwir.png",
  beefTeriyakiBowl:     "/marquee/beef-teriyaki-bowl.png",
  kopiSusuGulaAren:     "/marquee/kopi-susu-gula-aren.png",
};

const MENUS = [
  { name: "Nasi Kuning Komplit",     cat: "NASI · KOMPLIT",       price: 25000, desc: "Nasi kuning, ayam suwir, kacang, telur, sambal",       cook: "Rina Wulandari",   div: "Finance",       ribbon: "PROMO LAUNCHING 15%",  hue: 25,  img: M.nasiKuningKomplit },
  { name: "Beef Broccoli Bowl",      cat: "BOWL · DAGING",        price: 32000, desc: "Sapi lada hitam, brokoli, wortel, nasi putih",         cook: "Mia Azizah",       div: "CoOPS",         ribbon: "MENU TERBARU",         hue: 60,  img: M.beefBroccoliBowl },
  { name: "Es Kopi Susu",            cat: "MINUMAN · DINGIN",     price: 18000, desc: "Espresso, susu segar, gula aren, es batu",             cook: "Sari Anggraini",   div: "People Ops",    ribbon: "PALING SERING DIPESAN",hue: 100, img: M.esKopiSusu },
  { name: "Nasi Cumi Cabe Hijau",    cat: "NASI · SEAFOOD",       price: 30000, desc: "Cumi tumis cabe hijau, nasi hangat, kerupuk",          cook: "Dimas Saputra",    div: "ITdev",         ribbon: null,                   hue: 145, img: M.nasiCumiCabeHijau },
  { name: "Salad Ayam Panggang",     cat: "SEHAT · SALAD",        price: 35000, desc: "Ayam panggang, sayuran segar, dressing wijen",         cook: "Shinta Afiati",    div: "StratLink",     ribbon: "MENU TERBARU",         hue: 190, img: M.saladAyamPanggang },
  { name: "Nasi Ayam Salted Egg",    cat: "NASI & AYAM · GURIH",  price: 33000, desc: "Ayam salted egg, nasi putih, timun, sambal",           cook: "Ella Angela",      div: "Legal",         ribbon: "MENU TERLARIS",        hue: 230, img: M.nasiAyamSaltedEgg },
  { name: "Es Jeruk Peras",          cat: "MINUMAN · SEGAR",      price: 12000, desc: "Jeruk peras segar, sedikit gula, es batu",             cook: "Nadia Kusuma",     div: "Marketing",     ribbon: null,                   hue: 275, img: M.esJerukPeras },
  { name: "Es Kopi Hitam",           cat: "MINUMAN · KOPI",       price: 15000, desc: "Kopi tubruk, gula sedikit, es batu",                   cook: "Ahmad Hilal",      div: "Sales",         ribbon: "PROMO LAUNCHING 15%",  hue: 310, img: M.esKopiHitam },
  { name: "Nasi Kuning Ayam Suwir",  cat: "NASI · PORSI KANTOR",  price: 27000, desc: "Nasi kuning, ayam suwir, tempe orek, sambal",          cook: "Mayke Pranowo",    div: "Procurement",   ribbon: "MENU TERLARIS",        hue: 345, img: M.nasiKuningAyamSuwir },
  { name: "Beef Teriyaki Bowl",      cat: "BOWL · TERIYAKI",      price: 34000, desc: "Sapi teriyaki, nasi putih, wijen, edamame",            cook: "Teresa Adrianto",  div: "Data",          ribbon: null,                   hue: 15,  img: M.beefTeriyakiBowl },
  { name: "Kopi Susu Gula Aren",     cat: "MINUMAN · MANIS",      price: 20000, desc: "Espresso, susu segar, sirup gula aren, es batu",       cook: "Intan Permata",    div: "Customer Care", ribbon: "PALING SERING DIPESAN",hue: 125, img: M.kopiSusuGulaAren },
];

const rupiah = (n) => `Rp ${n.toLocaleString("id-ID")}`;
const initials = (n) => n.split(" ").filter(Boolean).slice(0, 2).map(w => w[0]).join("").toUpperCase();

const ALASAN = [
  ["01", "Lebih hemat dari aplikasi delivery. Biaya layanannya lebih rendah, dan tanpa ongkos kirim karena diproses langsung oleh rekan kerja."],
  ["02", "Rekan Masak di sini adalah rekan kerja sekantor. Setiap pesanan ikut mendukung usaha rumahan di kantor sendiri."],
  ["03", "Ada voucher untuk pesanan berulang, dan diskon khusus untuk pesanan pertama."],
  ["04", "Biaya platform paling ringan, tidak disembunyikan lewat ongkos kirim."],
  ["05", "Harga tetap sama meski hujan atau lalu lintas sedang sibuk. Tidak akan ada lonjakan harga tiba-tiba."],
];

const CHATS = [
  { side: "left",  top: "8%",  name: "Airinne", dept: "FINANCE",   color: "#0F01CA", msg: "asli enak next gue pesen ya buat seminggu skalian", anim: "float-l1", dur: "7.2s", delay: "-0.4s" },
  { side: "right", top: "30%", name: "Wildan",  dept: "COOPS",     color: "#0E9F9C", msg: "gak nyangka temen kantor kita ada yang barista, besok gw order lagi ya", anim: "float-r1", dur: "8.4s", delay: "-2.6s" },
  { side: "left",  top: "56%", name: "Dito",    dept: "ITDEV",     color: "#EB7B30", msg: "Mertua kamu gak buka restoran aja?", anim: "float-l2", dur: "6.4s", delay: "-4.1s" },
  { side: "right", top: "78%", name: "Mia",     dept: "STRATLINK", color: "#C21C7A", msg: "Eh gw jualan juga kali ya biar makin rame jajanan", anim: "float-r2", dur: "8.8s", delay: "-6.0s" },
];

const login = () => {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUrl = window.location.origin + "/menu";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

const CARA_STEPS = [
  { icon: "envelope-check", title: "Verifikasi Email Kantor",       body: "Ekosistem tertutup. Login wajib pakai email kantor, jadi kamu hanya bertransaksi dengan rekan kerja di gedung yang sama. Tanpa orang asing." },
  { icon: "clock",          title: "Sistem Pre-Order Jam 10 Malam", body: "Semua pesanan terkunci di jam 10 malam. Rekan Masak bisa tenang belanja bahan esok harinya, tanpa drama pesanan batal tiba-tiba." },
  { icon: "qr",             title: "Bayar Langsung, 100% Utuh",     body: "Tinggal scan QR dan transfer langsung ke rekening temanmu. Tidak ada uang yang ditahan aplikasi, dan tidak ada potongan komisi." },
  { icon: "cal-x",          title: "Mode Libur Kapan Saja",         body: "Jualan sesuai mood. Rekan Masak bisa tutup lapak dan istirahat kapan saja tanpa penalti, dan nggak perlu kasih alasan." },
];

const CaraIcon = ({ name }) => {
  const paths = {
    "envelope-check": (
      <>
        <rect x="3" y="6" width="18" height="12" rx="1.5" />
        <path d="M3 7l9 6 9-6" />
        <path d="M14 15l2 2 4-4" />
      </>
    ),
    clock: (
      <>
        <circle cx="12" cy="12" r="9" />
        <path d="M12 7v5l3 2" />
      </>
    ),
    qr: (
      <>
        <rect x="3" y="3" width="7" height="7" rx="1" />
        <rect x="14" y="3" width="7" height="7" rx="1" />
        <rect x="3" y="14" width="7" height="7" rx="1" />
        <path d="M14 14v3M17 14v7M20 17v4M14 17h3M17 20h3" />
      </>
    ),
    "cal-x": (
      <>
        <rect x="3" y="5" width="18" height="15" rx="1.5" />
        <path d="M3 9h18M8 3v4M16 3v4" />
        <path d="M10 13l4 4M14 13l-4 4" />
      </>
    ),
  };
  return (
    <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#26221E" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      {paths[name]}
    </svg>
  );
};

const CARA = [
  ["ShieldCheck", "Email kantor terverifikasi", "Masuk pakai email kantor sendiri, jadi Pembeli atau Rekan Masak dengan orang yang sama-sama kerja di gedungmu."],
  ["Lock", "Tanpa pembatalan", "Pesanan terkunci jam 10 malam, biar Rekan Masak bisa belanja bahan dengan tenang."],
  ["QrCode", "Bayar lewat QR, langsung ke Rekan Masak", "Tinggal scan dan transfer langsung. Dukungan pembayaran lokal lainnya segera menyusul."],
  ["Moon", "Mode Libur", "Rekan Masak bisa istirahat kapan aja, nggak perlu kasih alasan."],
];

const Icon = ({ name }) => {
  const paths = {
    ShieldCheck: "M12 3l7 3v6c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6l7-3zm-1.2 11.6l4.2-4.2-1.4-1.4-2.8 2.8-1.4-1.4-1.4 1.4 2.8 2.8z",
    Lock: "M12 2a5 5 0 015 5v3h1a2 2 0 012 2v8a2 2 0 01-2 2H6a2 2 0 01-2-2v-8a2 2 0 012-2h1V7a5 5 0 015-5zm0 2a3 3 0 00-3 3v3h6V7a3 3 0 00-3-3z",
    QrCode: "M3 3h8v8H3V3zm2 2v4h4V5H5zm8-2h8v8h-8V3zm2 2v4h4V5h-4zM3 13h8v8H3v-8zm2 2v4h4v-4H5zm8-2h3v3h-3v-3zm5 0h3v3h-3v-3zm-5 5h3v3h-3v-3zm5 0h3v3h-3v-3z",
    Moon: "M20 14.5A8.5 8.5 0 019.5 4a8.5 8.5 0 100 17 8.47 8.47 0 0010.5-6.5z",
  };
  return (
    <svg width="26" height="26" viewBox="0 0 24 24" aria-hidden="true" fill="currentColor">
      <path d={paths[name]} />
    </svg>
  );
};

export default function Landing() {
  const [tab, setTab] = useState("pemesan");
  const [role, setRole] = useState("pembeli");
  const [filled, setFilled] = useState(0);
  const [fading, setFading] = useState(false);
  const streakTimers = useRef([]);

  useEffect(() => {
    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    let current = 0;
    const push = (fn, ms) => {
      const id = setTimeout(fn, ms);
      streakTimers.current.push(id);
    };
    const tick = () => {
      current += 1;
      setFilled(current);
      if (current < 20) {
        const isCheckpoint = current === 5 || current === 10 || current === 15;
        push(tick, isCheckpoint ? 520 : 90);
      } else {
        push(() => {
          setFading(true);
          push(() => {
            setFading(false);
            current = 0;
            setFilled(0);
            push(tick, 120);
          }, 380);
        }, 2000);
      }
    };
    push(tick, 500);
    return () => {
      streakTimers.current.forEach(clearTimeout);
      streakTimers.current = [];
    };
  }, []);

  return (
    <div className="min-h-screen" style={{ background: "var(--cream)", color: "var(--ink)" }}>
      {/* NAV */}
      <header
        className="sticky top-0 z-40 backdrop-blur"
        style={{ background: "rgba(253,242,213,0.92)", borderBottom: "1px solid rgba(34,30,25,0.12)" }}
      >
        <div className="max-w-6xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
          <a href="#top" data-testid="landing-wordmark" className="font-display font-bold text-xl sm:text-2xl">
            Cookingin
          </a>
          <nav className="hidden sm:flex items-center gap-7 font-body text-sm font-semibold" style={{ color: "var(--muted)" }}>
            <a href="/untuk-pembeli" data-testid="nav-untuk-pemesan">Untuk Pembeli</a>
            <a href="/untuk-rekan-masak" data-testid="nav-untuk-koki">Untuk Rekan Masak</a>
            <a href="#cara-kerja" data-testid="nav-cara-kerja">Cara Kerja</a>
          </nav>
        </div>
      </header>

      {/* HERO */}
      <section id="top" className="mx-auto pt-10 pb-16 sm:pt-16 sm:pb-24" style={{ maxWidth: 1400, padding: "40px 24px 80px", overflowX: "hidden" }}>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(min(520px, 100%), 1fr))",
            gap: "clamp(2rem, 4vw, 3.5rem)",
            alignItems: "center",
          }}
        >
          <div className="reveal">
            <p className="font-mono-c text-[11px] sm:text-xs mb-5 tracking-widest uppercase" style={{ color: "var(--blue)" }}>
              OFFICE LUNCH MARKETPLACE
            </p>
            <h1 className="font-display" style={{ fontSize: "clamp(36px, 4.4vw, 52px)" }}>
              Kenyang bareng, teman sekantor.
            </h1>
            <p className="font-body mt-6 max-w-xl" style={{ color: "var(--muted)", fontSize: "clamp(18px, 1.9vw, 24px)", lineHeight: 1.45 }}>
              Jual-beli makan siang antar rekan sekantor. Sajian rumahan diantar tanpa perantara, dalam satu platform bebas ongkir.
            </p>
            <div className="flex flex-wrap gap-3 mt-9">
              <button
                data-testid="hero-pesan-sekarang"
                onClick={login}
                className="btn-orange font-body font-bold text-sm px-7 py-3.5"
                style={{ borderRadius: 3 }}
              >
                Pesan Sekarang
              </button>
              <button
                data-testid="hero-saya-koki"
                onClick={login}
                className="btn-blue font-body font-bold text-sm px-7 py-3.5"
                style={{ borderRadius: 3 }}
              >
                Saya Rekan Masak
              </button>
            </div>
            <p className="font-mono-c text-xs mt-5" style={{ color: "var(--muted)" }}>
              Lebih hemat buat yang pesan, nambah cuan buat yang masak.
            </p>
            <button
              data-testid="hero-coba-tamu"
              onClick={async () => {
                try {
                  await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/guest`, { method: "POST", credentials: "include" });
                  window.location.href = "/menu";
                } catch (err) {
                  console.error("Guest login failed:", err);
                }
              }}
              className="font-body text-xs mt-3 underline"
              style={{ color: "var(--muted)", background: "transparent", border: "none", cursor: "pointer", padding: 0 }}
            >
              atau coba sebagai tamu →
            </button>
          </div>

          <div className="reveal" style={{ animationDelay: "150ms", position: "relative", minWidth: 0 }}>
            <div
              data-testid="hero-visual-frame"
              className="relative"
              style={{
                border: "12px solid #1A17E0",
                borderRadius: 6,
                background: "#1A17E0",
                overflow: "visible",
                width: "100%",
                minWidth: "min(640px, 100%)",
                marginInline: "auto",
              }}
            >
              <div style={{ overflow: "hidden", borderRadius: 2 }}>
                <img
                  src={HERO_PHOTO}
                  alt="Meja kantor penuh sajian makan siang rumahan"
                  className="w-full block"
                  style={{
                    height: "clamp(580px, 78vw, 720px)",
                    objectFit: "cover",
                    objectPosition: "center 35%",
                  }}
                />
              </div>

              {/* Group pill */}
              <div
                data-testid="hero-group-pill"
                className="absolute"
                style={{
                  top: -22,
                  right: 18,
                  background: "#fff",
                  borderRadius: 999,
                  padding: "9px 15px",
                  boxShadow: "0 10px 22px rgba(38,34,30,0.16)",
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                  zIndex: 6,
                }}
              >
                <span
                  className="font-mono-c"
                  style={{ fontSize: 10, letterSpacing: "0.18em", color: "var(--ink)", fontWeight: 500 }}
                >
                  GRUP LUNCH LANTAI 8
                </span>
                <span className="typing-dots" aria-hidden="true">
                  <i /><i /><i />
                </span>
              </div>

              {/* Chat bubbles — viewport-scaled offsets so mobile scales gracefully */}
              <div aria-hidden="true">
                {CHATS.map((c) => {
                  const isLeft = c.side === "left";
                  return (
                    <div
                      key={c.name}
                      className="chat-bubble absolute"
                      data-testid={`hero-chat-${c.name.toLowerCase()}`}
                      style={{
                        top: c.top,
                        [isLeft ? "left" : "right"]: "clamp(-78px, -5vw, -14px)",
                        maxWidth: "min(300px, 62vw)",
                        animationName: c.anim,
                        animationDuration: c.dur,
                        animationDelay: c.delay,
                        zIndex: 5,
                      }}
                    >
                      <div
                        style={{
                          background: "#fff",
                          borderRadius: isLeft ? "22px 22px 22px 6px" : "22px 22px 6px 22px",
                          padding: "14px 16px",
                          boxShadow: "0 14px 26px rgba(38,34,30,0.18)",
                          display: "flex",
                          gap: 12,
                          alignItems: "flex-start",
                        }}
                      >
                        {isLeft && (
                          <span
                            style={{
                              width: 38, height: 38, borderRadius: "50%",
                              background: c.color, color: "#fff",
                              display: "grid", placeItems: "center",
                              fontWeight: 700, fontSize: 15, flexShrink: 0,
                            }}
                          >
                            {c.name[0]}
                          </span>
                        )}
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div style={{ display: "flex", gap: 8, alignItems: "baseline", flexWrap: "wrap" }}>
                            <span className="font-body" style={{ fontWeight: 700, color: c.color, fontSize: 14 }}>
                              {c.name}
                            </span>
                            <span
                              className="font-mono-c"
                              style={{ fontSize: 10, color: "var(--muted)", letterSpacing: "0.16em" }}
                            >
                              {c.dept}
                            </span>
                          </div>
                          <p
                            className="font-body"
                            style={{ fontSize: 15, lineHeight: 1.4, color: "var(--ink)", marginTop: 4 }}
                          >
                            {c.msg}
                          </p>
                        </div>
                        {!isLeft && (
                          <span
                            style={{
                              width: 38, height: 38, borderRadius: "50%",
                              background: c.color, color: "#fff",
                              display: "grid", placeItems: "center",
                              fontWeight: 700, fontSize: 15, flexShrink: 0,
                            }}
                          >
                            {c.name[0]}
                          </span>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* LINE-UP MENU MARQUEE */}
      <section
        data-testid="lineup-marquee"
        style={{ padding: "20px 0 130px", overflow: "hidden" }}
      >
        <div style={{ maxWidth: 1680, margin: "0 auto 46px", padding: "0 clamp(20px, 5vw, 56px)" }}>
          <p
            className="font-mono-c"
            style={{
              fontSize: 15,
              textTransform: "uppercase",
              color: "var(--blue)",
              letterSpacing: "0.22em",
              fontWeight: 500,
              margin: 0,
            }}
          >
            LINE UP MENU HARI INI
          </p>
          <h2
            className="font-display"
            style={{ fontSize: "clamp(32px, 5vw, 52px)", letterSpacing: "-0.02em", marginTop: 14 }}
          >
            Temukan kreasi menu rekan sekantormu
          </h2>
        </div>

        <div className="menu-marquee-viewport">
          <div className="menu-marquee-track" data-testid="menu-marquee-track">
            {[0, 1].map((pass) =>
              MENUS.map((m) => (
                <article
                  key={`${pass}-${m.name}`}
                  className="menu-card"
                  aria-hidden={pass === 1 ? "true" : undefined}
                  data-testid={pass === 0 ? `menu-card-${m.name.toLowerCase().replace(/\s+/g, "-")}` : undefined}
                >
                  <div style={{ position: "relative" }}>
                    <img
                      src={m.img}
                      alt={m.name}
                      loading="lazy"
                      style={{ width: "100%", height: 230, objectFit: "cover", display: "block" }}
                    />
                    {m.ribbon && (
                      <span
                        className="font-mono-c"
                        style={{
                          position: "absolute",
                          left: 0,
                          bottom: 10,
                          padding: "7px 14px 7px 20px",
                          borderRadius: "0 3px 3px 0",
                          background: RIBBON_COLORS[m.ribbon],
                          color: "#fff",
                          fontSize: 12,
                          fontWeight: 500,
                          letterSpacing: "0.1em",
                        }}
                      >
                        {m.ribbon}
                      </span>
                    )}
                  </div>
                  <div style={{ padding: "22px 22px 24px", display: "flex", flexDirection: "column", gap: 12, flex: 1 }}>
                    <h3 className="font-display" style={{ fontSize: 25, lineHeight: 1.15, margin: 0 }}>
                      {m.name}
                    </h3>
                    <p
                      className="font-body"
                      style={{ fontSize: 14, fontWeight: 700, letterSpacing: "0.04em", color: "var(--blue)", margin: 0 }}
                    >
                      {m.cat}
                    </p>
                    <p
                      className="font-body"
                      style={{ fontSize: 15, lineHeight: 1.45, color: "var(--muted)", margin: 0 }}
                    >
                      {m.desc}
                    </p>
                    <p
                      className="font-mono-c"
                      style={{ fontSize: 20, fontWeight: 500, color: "var(--ink)", margin: 0 }}
                    >
                      {rupiah(m.price)}
                    </p>
                    <div style={{ height: 1, background: "rgba(38,34,30,0.10)", margin: "2px 0" }} />
                    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                      <span
                        style={{
                          width: 30,
                          height: 30,
                          borderRadius: "50%",
                          background: `oklch(0.55 0.16 ${m.hue})`,
                          color: "#fff",
                          display: "grid",
                          placeItems: "center",
                          fontWeight: 700,
                          fontSize: 11,
                          fontFamily: "'Nunito Sans', sans-serif",
                          letterSpacing: "0.02em",
                          flexShrink: 0,
                        }}
                      >
                        {initials(m.cook)}
                      </span>
                      <span className="font-body" style={{ fontSize: 14, color: "var(--muted)" }}>
                        {m.cook} · {m.div}
                      </span>
                    </div>
                    <button
                      className="btn-orange font-body font-bold"
                      style={{
                        minHeight: 50,
                        borderRadius: 4,
                        marginTop: "auto",
                        fontSize: 14,
                        letterSpacing: "0.01em",
                      }}
                      onClick={login}
                    >
                      Tambah ke Keranjang
                    </button>
                  </div>
                </article>
              ))
            )}
          </div>
        </div>
      </section>

      {/* KENAPA */}
      <section
        data-testid="kenapa-section"
        style={{ maxWidth: 1680, margin: "0 auto", padding: "30px clamp(20px, 5vw, 56px) 140px" }}
      >
        <h2
          className="font-display"
          style={{ fontSize: "clamp(32px, 5vw, 52px)", letterSpacing: "-0.02em", marginBottom: 52 }}
        >
          Kenapa Pilih Cookingin
        </h2>
        <div className="kenapa-grid">
          {ALASAN.map(([num, text]) => (
            <div
              key={num}
              data-testid={`alasan-${num}`}
              className="kenapa-card reveal"
              style={{ animationDelay: `${parseInt(num, 10) * 60}ms` }}
            >
              <span className="kenapa-num">{num}</span>
              <p style={{ margin: 0 }}>{text}</p>
            </div>
          ))}
        </div>
      </section>

      {/* DUAL-POV — Apa peranmu hari ini? */}
      <section
        id="pemesan"
        data-testid="dual-pov-section"
        style={{
          maxWidth: 1680,
          margin: "0 auto",
          padding: "10px clamp(20px,4vw,56px) clamp(90px,10vw,150px)",
        }}
      >
        <div style={{
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "space-between",
          gap: 32,
          flexWrap: "wrap",
          marginBottom: 40,
        }}>
          <div>
            <p className="font-mono-c" style={{
              fontSize: 15, textTransform: "uppercase", color: "#1A17E0",
              letterSpacing: "0.22em", fontWeight: 500, margin: 0,
            }}>DUA SISI SATU GEDUNG</p>
            <h2 className="font-display" style={{
              fontSize: "clamp(32px, 4vw, 52px)", letterSpacing: "-0.02em", marginTop: 14, marginBottom: 0,
            }}>Apa peranmu hari ini?</h2>
          </div>
          <p className="font-mono-c" style={{
            fontSize: 13, textTransform: "uppercase", color: "#9A9084",
            letterSpacing: "0.16em", margin: 0,
          }} data-testid="pov-counter">
            {role === "pembeli" ? "01 / 02 — PEMBELI" : "02 / 02 — REKAN MASAK"}
          </p>
        </div>

        <div style={{
          background: "#fff",
          borderRadius: 22,
          boxShadow: "0 18px 50px rgba(38,34,30,0.12)",
          padding: "clamp(26px,3vw,44px)",
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(min(420px, 100%), 1fr))",
          gap: "clamp(30px,4vw,60px)",
          alignItems: "stretch",
        }}>
          <div style={{ display: "flex", flexDirection: "column", minHeight: "clamp(420px,46vw,560px)" }}>
            <div style={{ display: "flex", gap: 14, marginBottom: 38, flexWrap: "wrap" }}>
              <button
                type="button"
                data-testid="pov-tab-pembeli"
                onClick={() => setRole("pembeli")}
                className={`pov-tab ${role === "pembeli" ? "active" : ""}`}
              >Pembeli</button>
              <button
                type="button"
                data-testid="pov-tab-rekan"
                onClick={() => setRole("rekan")}
                className={`pov-tab ${role === "rekan" ? "active" : ""}`}
              >Rekan Masak</button>
            </div>

            <h3 className="font-display" style={{
              fontSize: "clamp(28px, 3.1vw, 42px)", lineHeight: 1.15,
              letterSpacing: "-0.02em", margin: "0 0 22px", textWrap: "pretty",
            }}>
              {role === "pembeli" ? (
                <>Makan siang terencana, dompet lebih aman. Bebas <em style={{ fontStyle: "italic" }}>surge pricing</em> saat jam sibuk, karena yang masak teman sendiri.</>
              ) : (
                <>Bawa bekal, bawa pulang cuan. Sistem <em style={{ fontStyle: "italic" }}>Pre-Order</em> bikin kamu masak sesuai jumlah pesanan. Laku, tanpa takut ada porsi sisa.</>
              )}
            </h3>

            <p className="font-body" style={{
              fontSize: "clamp(16px, 1.5vw, 19px)", lineHeight: 1.6,
              color: "#6E6559", maxWidth: "46ch", marginTop: 0, marginBottom: 34,
            }}>
              {role === "pembeli"
                ? "Pesan pagi, makan siang besok tepat waktu di meja sendiri. Tanpa kurir, tanpa antri dan tanpa biaya tersembunyi"
                : "Mulai dari dapur rumah, tanpa sewa tempat dan tanpa stok mubazir. Pembelinya rekan kerja yang sudah kamu kenal."}
            </p>

            <ol style={{
              display: "flex", flexDirection: "column", gap: 14,
              marginBottom: 38, listStyle: "none", padding: 0, marginTop: 0,
            }}>
              {(role === "pembeli"
                ? [
                    "Buka line up menu rekan sekantor, pilih porsi hari ini.",
                    "Pre-order sebelum jam 10 malam, bayar langsung ke rekan yang masak",
                    "Ambil di pantry lantaimu saat jam makan siang.",
                  ]
                : [
                    "Upload menu dan kuota porsi untuk besok.",
                    "Order terkunci malam ini, masak sesuai jumlah pesanan.",
                    "Sekali antar ke pantry, uang masuk ke rekeningmu.",
                  ]
              ).map((step, idx) => (
                <li key={`step-${idx}-${step.slice(0, 20)}`} style={{ display: "flex", alignItems: "flex-start", gap: 16 }}>
                  <span style={{
                    width: 30, height: 30, borderRadius: "50%",
                    background: "#FBEFD3", color: "#1A17E0",
                    display: "grid", placeItems: "center",
                    fontFamily: "'IBM Plex Mono', monospace", fontWeight: 500, fontSize: 13,
                    flexShrink: 0,
                  }}>{idx + 1}</span>
                  <span style={{ fontSize: 17, lineHeight: 1.5, color: "#26221E" }}>{step}</span>
                </li>
              ))}
            </ol>

            <div style={{
              marginTop: "auto",
              background: "#F0B429",
              borderRadius: 4,
              padding: "24px 26px 26px",
            }}>
              <p className="font-mono-c" style={{
                fontSize: 12, textTransform: "uppercase", letterSpacing: "0.14em",
                color: "rgba(38,34,30,0.62)", margin: 0, fontWeight: 500,
              }}>{role === "pembeli" ? "CERITA PEMBELI" : "CERITA REKAN MASAK"}</p>
              <p style={{
                fontSize: 17, lineHeight: 1.65, color: "#26221E",
                textWrap: "pretty", marginTop: 10, marginBottom: 0,
              }}>
                {role === "pembeli"
                  ? "Johan (Marketing) sudah tenang. Jadwal makan siangnya seminggu ke depan aman berkat Nasi Bakar buatan Wendy. Harga stabil, meski di luar sedang hujan badai."
                  : "Wendy (Finance) upload menu bekal andalan ibunya di jam 12 siang. Malamnya, ia sudah kantongin 18 pesanan dari teman-teman kantornya."}
              </p>
            </div>
          </div>

          <div id="koki" style={{
            position: "relative", borderRadius: 16, overflow: "hidden",
            background: "#F3E2BE", minHeight: "clamp(340px, 42vw, 560px)",
          }}>
            <img
              src={POV_PEMBELI}
              alt="POV Pembeli — meja makan siang kantor"
              className={`pov-photo ${role === "pembeli" ? "active" : ""}`}
              data-testid="pov-photo-pembeli"
            />
            <img
              src={POV_REKAN}
              alt="POV Rekan Masak — masak bareng keluarga di dapur rumah"
              className={`pov-photo ${role === "rekan" ? "active" : ""}`}
              data-testid="pov-photo-rekan"
            />

            <div style={{
              position: "absolute", left: 0, right: 0, bottom: 0,
              height: "46%",
              background: "linear-gradient(to top, rgba(38,34,30,0.72), rgba(38,34,30,0))",
              pointerEvents: "none", zIndex: 3,
            }} />

            <div style={{
              position: "absolute", left: 22, bottom: 22,
              display: "flex", gap: 12, flexWrap: "wrap", zIndex: 4,
            }}>
              <span className="font-mono-c" style={{
                fontSize: 12, textTransform: "uppercase", letterSpacing: "0.1em",
                borderRadius: 999, padding: "9px 16px",
                background: "#fff", color: "#1A17E0", fontWeight: 500,
              }}>{role === "pembeli" ? "POV PEMBELI" : "POV REKAN MASAK"}</span>
              <span className="font-mono-c" style={{
                fontSize: 12, textTransform: "uppercase", letterSpacing: "0.1em",
                borderRadius: 999, padding: "9px 16px",
                background: "rgba(255,255,255,0.16)",
                border: "1px solid rgba(255,255,255,0.5)",
                color: "#fff", fontWeight: 500,
              }}>{role === "pembeli" ? "PANTRY LANTAI 8 · 12.00" : "DAPUR RUMAH · 21.00"}</span>
            </div>
          </div>
        </div>
      </section>

      {/* CARA KERJA — full-bleed blue */}
      <section id="cara-kerja" style={{
        background: "#1A17E0", color: "#fff",
        padding: "clamp(70px,8vw,110px) clamp(20px,4vw,56px) clamp(90px,10vw,130px)",
      }}>
        <div style={{ maxWidth: 1680, margin: "0 auto" }}>
          <p className="font-mono-c" style={{
            fontSize: 15, textTransform: "uppercase", letterSpacing: "0.22em",
            color: "#F0B429", margin: "0 0 22px", fontWeight: 500,
          }}>ATURAN MAINNYA SEDERHANA</p>
          <h2 className="font-display" style={{
            fontSize: "clamp(32px, 4vw, 52px)", lineHeight: 1.05,
            letterSpacing: "-0.02em", color: "#fff",
            margin: "0 0 clamp(38px, 4vw, 58px)",
          }}>Cara Kerja Cookingin</h2>

          <div className="cara-grid">
            {CARA_STEPS.map((c, i) => (
              <div key={c.title} className="cara-card" data-testid={`cara-kerja-${i + 1}`}>
                <span style={{
                  width: 58, height: 58, borderRadius: "50%",
                  background: "#F0B429",
                  display: "grid", placeItems: "center",
                  flexShrink: 0,
                }}>
                  <CaraIcon name={c.icon} />
                </span>
                <span className="font-mono-c" style={{
                  fontSize: 12, letterSpacing: "0.14em", opacity: 0.72, fontWeight: 500,
                }}>{String(i + 1).padStart(2, "0")}</span>
                <h3 className="font-display" style={{
                  fontSize: 24, lineHeight: 1.2, letterSpacing: "-0.01em",
                  margin: 0, color: "inherit",
                }}>{c.title}</h3>
                <p className="font-body" style={{
                  fontSize: 16, lineHeight: 1.6, color: "inherit",
                  opacity: 0.9, textWrap: "pretty", margin: 0,
                }}>{c.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* STREAK — same blue continues */}
      <section data-testid="streak-section" style={{
        background: "#1A17E0", color: "#fff",
        padding: "clamp(20px,3vw,40px) clamp(20px,4vw,56px) clamp(90px,10vw,130px)",
      }}>
        <div style={{ maxWidth: 1180, margin: "0 auto", textAlign: "center" }}>
          <p className="font-mono-c" style={{
            fontSize: 14, textTransform: "uppercase", letterSpacing: "0.22em",
            color: "#F0B429", margin: "0 0 22px", fontWeight: 500,
          }}>MAKIN SERING, MAKIN MURAH</p>
          <h2 className="font-display" style={{
            fontSize: "clamp(32px, 4vw, 52px)", lineHeight: 1.05,
            letterSpacing: "-0.02em", color: "#fff", margin: 0,
          }}>Pesan Terus, Dapet Terus</h2>
          <p className="font-body" style={{
            fontSize: "clamp(16px, 1.6vw, 19px)", lineHeight: 1.6,
            color: "rgba(255,255,255,0.82)", maxWidth: "62ch",
            margin: "24px auto clamp(46px,5vw,66px)",
            textWrap: "pretty",
          }}>Tiap 5 hari berturut-turut pesan, dapet voucher diskon. Genap 4 minggu (20 hari kerja), voucher ke-4 naik jadi 20% dan siklus mulai lagi dari awal. Kelewat satu hari, streak balik ke nol.</p>

          <div style={{
            border: "1px solid rgba(255,255,255,0.28)",
            borderRadius: 22,
            background: "rgba(255,255,255,0.07)",
            padding: "clamp(34px,4vw,48px) clamp(18px,3vw,40px) clamp(26px,3vw,34px)",
          }}>
            <div className="streak-grid">
              {Array.from({ length: 20 }, (_, i) => {
                const day = i + 1;
                const isCheckpoint = day === 5 || day === 10 || day === 15 || day === 20;
                const isBig = day === 20;
                const reached = day <= filled && !fading;
                const size = isBig ? 38 : isCheckpoint ? 30 : 22;
                const badgeText = day === 5 ? "5%" : day === 10 ? "10%" : day === 15 ? "10%" : day === 20 ? "20%" : "";
                return (
                  <div key={day} style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 10 }}>
                    <span style={{
                      minHeight: isBig ? 26 : 20,
                      display: "grid", placeItems: "center",
                    }}>
                      {isCheckpoint && (
                        <span
                          className="font-mono-c"
                          style={{
                            visibility: reached ? "visible" : "hidden",
                            background: "#E8823A",
                            color: "#fff",
                            fontWeight: 500,
                            borderRadius: 4,
                            fontSize: isBig ? 14 : 11,
                            padding: isBig ? "6px 12px" : "3px 7px",
                            animation: reached ? "badgeIn 420ms cubic-bezier(.34,1.56,.64,1) both" : "none",
                          }}
                        >{badgeText}</span>
                      )}
                    </span>
                    <span
                      className="streak-marker"
                      style={{
                        width: size, height: size, borderRadius: "50%",
                        background: reached ? (isCheckpoint ? "#E8823A" : "#F0B429") : "transparent",
                        border: reached
                          ? `2px solid ${isCheckpoint ? "#E8823A" : "#F0B429"}`
                          : "2px solid rgba(255,255,255,0.38)",
                        transition: "opacity 360ms ease",
                        opacity: fading && !reached ? 0.15 : 1,
                        animation: reached
                          ? (isBig
                              ? "popBig 620ms cubic-bezier(.34,1.56,.64,1), glow 1200ms ease-out"
                              : isCheckpoint
                                ? "popBig 520ms cubic-bezier(.34,1.56,.64,1), glow 900ms ease-out"
                                : "pop 320ms cubic-bezier(.34,1.56,.64,1)")
                          : "none",
                      }}
                    />
                    <span className="font-mono-c" style={{ fontSize: 11, color: "rgba(255,255,255,0.6)" }}>
                      {String(day).padStart(2, "0")}
                    </span>
                  </div>
                );
              })}
            </div>
            <p className="font-body" style={{
              marginTop: "clamp(24px,3vw,32px)",
              fontSize: 14,
              color: "rgba(255,255,255,0.62)",
              marginBottom: 0,
            }}>Siklus berulang tiap 20 hari kerja</p>
          </div>
        </div>
      </section>

      {/* CLOSING */}
      <section style={{
        background: "#fff",
        padding: "clamp(80px,9vw,120px) clamp(20px,4vw,56px) clamp(90px,10vw,140px)",
      }}>
        <div style={{ maxWidth: 1680, margin: "0 auto" }}>
          <div style={{ textAlign: "center", marginBottom: "clamp(44px,5vw,64px)" }}>
            <p className="font-mono-c" style={{
              fontSize: 14, textTransform: "uppercase", letterSpacing: "0.22em",
              color: "#1A17E0", margin: "0 0 20px", fontWeight: 500,
            }}>MULAI DARI MAKAN SIANG BESOK</p>
            <h2 className="font-display" style={{
              fontSize: "clamp(32px, 4vw, 52px)", lineHeight: 1.05,
              letterSpacing: "-0.02em", color: "#26221E", margin: 0,
            }}>Pilih peranmu, gabung hari ini.</h2>
          </div>

          <div className="closing-grid">
            <div style={{
              background: "#26221E", color: "#fff", borderRadius: 22,
              padding: "clamp(38px,4vw,58px) clamp(30px,3.4vw,52px) clamp(38px,4vw,54px)",
              display: "flex", flexDirection: "column", gap: 20,
              minHeight: "clamp(320px,30vw,400px)",
            }}>
              <p className="font-mono-c" style={{
                fontSize: 12, textTransform: "uppercase", letterSpacing: "0.16em",
                color: "#F0B429", margin: 0, fontWeight: 500,
              }}>PEMBELI</p>
              <h3 className="font-display" style={{
                fontSize: "clamp(28px,2.9vw,40px)", lineHeight: 1.12,
                letterSpacing: "-0.02em", margin: 0, textWrap: "pretty",
              }}>Makan siang, tinggal ambil ke pantry.</h3>
              <p style={{
                fontSize: "clamp(16px,1.5vw,19px)", lineHeight: 1.6,
                color: "rgba(255,255,255,0.76)", maxWidth: "40ch",
                margin: 0, textWrap: "pretty",
              }}>Bebas antre panjang di luar, bebas ongkir mahal. Cek menu masakan rekan sekantormu hari ini.</p>
              <button
                data-testid="closing-pesan-sekarang"
                onClick={login}
                className="font-body closing-orange-btn"
                style={{
                  marginTop: "auto", alignSelf: "flex-start",
                  minHeight: 62, padding: "0 40px", borderRadius: 4,
                  fontWeight: 700, fontSize: 19, color: "#fff",
                  background: "#E8823A", border: "none", cursor: "pointer",
                  transition: "background 180ms ease",
                }}
              >Pesan Sekarang</button>
            </div>

            <div style={{
              background: "#fff", color: "#26221E", borderRadius: 22,
              padding: "clamp(38px,4vw,58px) clamp(30px,3.4vw,52px) clamp(38px,4vw,54px)",
              display: "flex", flexDirection: "column", gap: 20,
              minHeight: "clamp(320px,30vw,400px)",
              border: "1px solid rgba(38,34,30,0.14)",
              boxShadow: "0 14px 40px rgba(38,34,30,0.08)",
            }}>
              <p className="font-mono-c" style={{
                fontSize: 12, textTransform: "uppercase", letterSpacing: "0.16em",
                color: "#1A17E0", margin: 0, fontWeight: 500,
              }}>REKAN MASAK</p>
              <h3 className="font-display" style={{
                fontSize: "clamp(28px,2.9vw,40px)", lineHeight: 1.12,
                letterSpacing: "-0.02em", margin: 0, textWrap: "pretty",
              }}>Ubah masakan dapur jadi ekstra cuan.</h3>
              <p style={{
                fontSize: "clamp(16px,1.5vw,19px)", lineHeight: 1.6,
                color: "#6E6559", maxWidth: "40ch",
                margin: 0, textWrap: "pretty",
              }}>Buka Pre-Order ke teman sekantor, masak dengan tenang tanpa takut ada porsi sisa.</p>
              <button
                data-testid="closing-untuk-koki"
                onClick={login}
                className="font-body closing-blue-btn"
                style={{
                  marginTop: "auto", alignSelf: "flex-start",
                  minHeight: 62, padding: "0 40px", borderRadius: 4,
                  fontWeight: 700, fontSize: 19, color: "#fff",
                  background: "#1A17E0", border: "none", cursor: "pointer",
                  transition: "background 180ms ease",
                }}
              >Saya Rekan Masak</button>
            </div>
          </div>
        </div>
      </section>

      <footer style={{ borderTop: "1px solid rgba(34,30,25,0.12)" }}>
        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-10 flex flex-col sm:flex-row gap-4 sm:items-center justify-between">
          <p className="font-display font-bold text-lg">Cookingin</p>
          <p className="font-mono-c text-xs" style={{ color: "var(--muted)" }}>
            Masuk dengan email kantor · Satu gedung, satu dapur bersama
          </p>
          <p className="font-mono-c text-xs" style={{ color: "var(--muted)" }}>© 2026 Cookingin</p>
        </div>
      </footer>
    </div>
  );
}
